import {IAppContextState} from "./AppContext.interfaces";
import {useTeamsContext} from "services/TeamsContext/TeamsContext.hook";
import {useEffect} from "react";
import {useConfigurationContext} from "services/ConfigurationContext/ConfigurationContext.hook";
import {useUserContext} from "services/UsersContext/UsersContext.hook";
import {useTopicsContext} from "../TopicsContext/TopicsContext.hook";
import {useLanguagesContext} from "../LanguagesContext/LanguagesContext.hook";
import {useUsersListsContext} from "../UsersListsContext/UsersListsContext.hook";
import {useTenantContext} from "../TenantContext/TenantContext.hook";
import { useGptContext } from "services/GptContext/GptContext.hook";

export const useAppContext = (): IAppContextState => {
    const configurationContext = useConfigurationContext();
    const teamsContext = useTeamsContext(configurationContext);
    const userContext = useUserContext(teamsContext);
    const topicContext = useTopicsContext(teamsContext);
    const languagesContext = useLanguagesContext(teamsContext);
    const usersListsContext = useUsersListsContext(teamsContext);
    const tenantContext = useTenantContext(teamsContext);
    const gptcontext = useGptContext(teamsContext);

    useEffect(function onConfigurationLoaded() {
        (async () => {
            if (!teamsContext.initialized || teamsContext.loaded || !configurationContext.loaded) return;
            const configurationData = configurationContext?.data;
            if (!configurationData?.clientId) return;
            const clientId = configurationData.clientId;
            const graphScopes = configurationData.graphScopes.split(" ");
            await teamsContext.initializeTeamsFx(clientId, graphScopes);
        })()
    }, [teamsContext.initialized, teamsContext.loaded, configurationContext?.data]);

    return {
        initialized: teamsContext.initialized,
        loaded: teamsContext.loaded && userContext.loaded && topicContext.loaded && tenantContext.loaded,
        configuration: configurationContext,
        teams: teamsContext,
        users: userContext,
        topics: topicContext,
        languages: languagesContext,
        usersLists: usersListsContext,
        tenant: tenantContext,
        gpts: gptcontext
    }
}